import { useLocation } from "react-router-dom";
import { ComponentType } from "./model/enums";
import { Part } from "./model/model";
import { selectIdToken, signInUser } from "./reducers/authSlice";
import { AppState } from "./store";

export const endOfThisDay = (date: Date) => {
  let newDate = new Date(date);
  newDate.setFullYear(date.getFullYear());
  newDate.setHours(23, 59, 59, 59);
  return newDate;
};

export const startOfThisDay = (date: Date) => {
  let newDate = new Date(date);
  newDate.setFullYear(date.getFullYear());
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

export enum QueryType {
  User = "user",
  Dashboard = "dashboard",
}

export const UNDEFINED_DEVICE_ID = "undefined-device-id";
export const UNDEFINED_PART_ID = "undefined-part-type_undefined-part-id";
export const UNDEFINED_APP_ID = "undefined-app-id";

export const noCompany = {companyId : "none", name : "- None -"}

export function getEnumKeyByEnumValue<T extends { [index: string]: string }>(
  myEnum: T,
  enumValue: string
): keyof T | string {
  let keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue);
  return keys.length > 0 ? keys[0] : '';
}

export const imageForPart = (part: Part, thumbnail: boolean = true) => {
  let type = "UNDEFINED"
  if (part !== undefined) {
    type = mcVersionToUppercaseFormat(part.mcVersion)
  }
  
  return thumbnail ? `/parts/thumbnails/${type}.png` : `/parts/${type}.png`
}

export const remainingLifePercents = (part: Part) : number => {
  return (100 - (+part.utilisation * 100) / 10000) || 0
}

export const partUid = (type: ComponentType, sn: string) => {
  return `${type}_${sn}`
}

// lc_b13a_300 -> LCB13A300
export const mcVersionToUppercaseFormat = (mcVersion: string): string => {
  return mcVersion.replace('_', '').toUpperCase()
}

export const partTypeSn = (partUid: string) => {
  const [type, sn] = [partUid.split('_')[0], partUid.split('_').slice(1).join('_')]
  return {componentType: type as ComponentType, sn: sn}
}

export const iotDeviceSubId = (name: string): string => {
  return name.split('-').slice(1).join('-')
}

export const appComponentShortName = (name: string): string => {
  return name.split('.app.')[1]
}

export const getErrorMessage = (error: any): string => {
  let errMsg: string = 'error'
  if ('status' in error) {
    // you can access all properties of `FetchBaseQueryError` here
    errMsg = 'error' in error ? error.error : 
      'message' in error.data ? error.data.message : JSON.stringify(error.data)
  }
  else {
    // you can access all properties of `SerializedError` here
    errMsg = error.message
  }
  return errMsg
}

export const tokenFn = (thunkAPI: any): () => Promise<string> => {
  return async () => { 
    await thunkAPI.dispatch(signInUser())
    const token = selectIdToken(thunkAPI.getState() as AppState)
    return token
  }
}

export function timeSince(date: number) {
  var seconds = Math.floor((new Date().getTime() - date) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

export function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation()

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i]
    const possibleMatch = pathname.endsWith(pattern)
    if (possibleMatch) {
      return pattern
    }
  }

  return undefined
}

